<div class="chart-with-calculator-component" fxLayout="column">
    <div fxLayout="column" class="chart-with-input-component_form">
        <p class="text-12-semi-bold">
            Taxa de retorno<i class="fa-solid fa-circle-info"></i>
        </p>
        <div
            class="chart-with-input-component_form-currency"
            fxLayout="row"
            fxLayoutAlign="space-between none"
            style="width: 160px"
        >
            <dsn-input
                style="width: 100%"
                [size]="'medium'"
                [type]="'number'"
                [placeholder]="'0,00'"
                [disabled]="false"
                [value]="currency"
                [name]="'currency'"
                [id]="'currency-field'"
                [isInvalid]="false"
                [noValidate]="false"
                [invalidMessage]="'Informação obrigatória'"
                (onValueChange)="onRateChange($event)"
            ></dsn-input>
        </div>
    </div>
    <div fxLayout="column">
        <app-highcharts-render
            style="height: 100%"
            [options]="options"
            [visualization]="visualization"
            [series]="series"
            [points]="points"
            [company]="company"
        ></app-highcharts-render>
    </div>
</div>
